import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSubTitle } from "../../store/Subtitle/subTitleSlice";
const actionTabs = [
  {
    type: "delete",
    label: "Delete",
    icon: "/tool/dashboard/static/images/icons/subtitle/delete.svg",
  },
  // {
  //   type: "undo",
  //   label: "Undo",
  //   icon: "/subtitle/static/images/icons/subtitle/undo.svg",
  // },
  {
    type: "edit",
    label: "Edit",
    icon: "/tool/dashboard/static/images/icons/subtitle/edit.svg",
  },
];
const EditTextPopover = () => {
  const dispatch = useDispatch();
  const [seletedItem, setSelectedItem] = useState(null);
  const [action, setAction] = useState(null);
  const [input, setInput] = useState("");
  const { subTitle } = useSelector((state) => state.subTitle);
  const onBlur = () => {
    if (input && seletedItem && action === "edit") {
      const tempSubtitle = [...subTitle];
      const index = tempSubtitle.findIndex(
        (data) => data.id === seletedItem.id
      );
      tempSubtitle[index] = { ...tempSubtitle[index], text: input };
      dispatch(setSubTitle(tempSubtitle));
    }
    setAction(null);
    setInput("");
    setSelectedItem(null);
  };
  const onDelete = () => {
    const tempSubtitle = [...subTitle];
    const index = tempSubtitle.findIndex((data) => data.id === seletedItem.id);
    tempSubtitle.splice(index, 1);
    dispatch(setSubTitle(tempSubtitle));
  };
  const onActionSelect = (tab) => {
    if (tab === "delete") {
      onDelete();
    }
    setAction(tab);
    setInput(seletedItem?.text || "");
  };
  return (
    <div className="w-full">
      <div className="flex items-center pl-[25px]  h-[56px] font-medium bg-gradient-sidebar">
        Edit Text
      </div>
      <div className="pt-4 pl-[22px] pr-[15px]">
        <div className="w-full h-[285px] bg-white px-6 py-[30px] rounded-[5px] border overflow-y-auto flex gap-x-2 gap-y-[53px] flex-wrap">
          {subTitle.map((data, index) => {
            const isSelected = seletedItem?.id === data.id;

            return (
              <>
                {!(isSelected && action === "edit") ? (
                  <div
                    className={`p-3 border border-[#11142D4D] text-sm text-[#11142DB2] font-medium rounded-[5px] cursor-pointer h-fit ${
                      isSelected && "bg-[#11142D26]"
                    }`}
                    key={index}
                    onClick={() => setSelectedItem(data)}
                  >
                    {data.text}
                  </div>
                ) : (
                  <input
                    className={`!w-[100px] p-3 border border-[#11142D4D] rounded-[5px] h-[46px]`}
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onBlur={onBlur}
                    autoFocus
                  />
                )}
              </>
            );
          })}
        </div>
      </div>
      <div className="pt-[11px] pl-[22px] flex gap-2">
        {actionTabs.map((tab, index) => (
          <div
            className="flex gap-1 px-3 py-2 border border-[#173E6733] rounded items-center cursor-pointer"
            key={index}
            onClick={() => {
              onActionSelect(tab.type);
            }}
          >
            <img src={tab.icon} className="w-4 h-4 cursor-pointer" />
            <span className="font-semibold text-sm text-[#11142DCC]">
              {tab.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EditTextPopover;
